export type SegmentationSidebarMode =
  | "segmentation-study"
  | "standard-findings"
  | "prediction-readonly"
  | "none";

export type SegmentationStudyTemplateMode = "ai" | "model" | "blank";
export type SegmentationAnnotationMode = "idle" | "new" | "edit";

/** Blank study arms must not reveal prediction-derived marks, masks, or cards. */
export function shouldShowSegmentationStudyPredictions(
  templateMode: SegmentationStudyTemplateMode | undefined,
): boolean {
  return templateMode !== "blank";
}

/** Keep geometry editing exclusive to the explicit segmentation-study shell. */
export function resolveSegmentationSidebarMode({
  isSegmentationStudy,
  findingCount,
  predictionCount,
}: {
  isSegmentationStudy: boolean;
  findingCount: number;
  predictionCount: number;
}): SegmentationSidebarMode {
  if (isSegmentationStudy) return "segmentation-study";
  if (findingCount > 0) return "standard-findings";
  if (predictionCount > 0) return "prediction-readonly";
  return "none";
}
